import toggleClass from 'utils/DOM/toggleClass'

function renderError() {
  toggleClass(document.body, 'error-quote', true)
  toggleClass(document.body, 'show-loading', false)
}

export default renderError
